import { useAttachFileToUser } from "@coaching-culture/api-client";
import {
  Box,
  Button,
  FormInput,
  FormInputWrap,
  FormTextArea,
  Modal,
  Text,
  PanelHeader,
  NewFileUploader,
} from "@coaching-culture/ui";
import { Controller, useForm } from "react-hook-form";

export type UploadDocumentModalProps = {
  userId: string;
  conversationId?: string;
  onClose: () => void;
};

type UploadFormType = {
  name: string;
  description: string;
  fileId: string;
};

export const UploadDocumentModal = ({
  userId,
  conversationId,
  onClose,
}: UploadDocumentModalProps) => {
  const createDocument = useAttachFileToUser();

  const { register, errors, control, handleSubmit } = useForm<UploadFormType>();

  const onSubmit = async (values: UploadFormType) => {
    await createDocument.mutateAsync({
      ...values,
      conversationId,
      userId,
    });
    onClose();
  };

  return (
    <Modal width={600} onClose={onClose} showCloseButton>
      <PanelHeader>
        <Text fontSize={3} fontWeight={600}>
          Upload New Document
        </Text>
      </PanelHeader>
      <Box p={3}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <FormInput
            name="name"
            label="Name"
            ref={register({ required: true })}
            error={errors.name}
          />
          <FormTextArea
            name="description"
            label="Description"
            ref={register}
            error={errors.description}
          />
          <Controller
            control={control}
            name="fileId"
            rules={{ required: true }}
            render={({ onChange }) => (
              <FormInputWrap label="File" mb={5}>
                <NewFileUploader onChange={(val) => onChange(val.fileId)} />
              </FormInputWrap>
            )}
          />
          <Button type="submit" mr={1} color="primary">
            Save
          </Button>
          <Button type="button" onClick={onClose}>
            Close
          </Button>
        </form>
      </Box>
    </Modal>
  );
};
